// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"q8-z","refreshPageWarning":"r8-z","redirectMessageText":"s8-z"};